import {
  stenaCheckCircle,
  stenaClock,
  stenaSailingOnRoute,
  stenaStatisticsBar,
} from "@stenajs-webui/elements";
import { cssColor } from "@stenajs-webui/theme";
import { parseISO } from "date-fns";
import type { FC } from "react";

import { formatShipName } from "../common/formatters/formatShipName";
import type { SailingType } from "../common/graphql/fragments/gql/SailingType";
import { formatDateTime } from "../common/utils/dates/dateUtils";
import { SailingInfoItem } from "./sailing-info/SailingInfoItem";

interface TripDetailsProps {
  arrivalInformation?: string | null;
  dateFormat: string;
  releasedAt?: string | null;
  sailingType?: SailingType;
  shipName?: string;
}

export const TripDetails: FC<TripDetailsProps> = ({
  sailingType,
  arrivalInformation,
  releasedAt,
  shipName,
  dateFormat,
}) => (
  <>
    {shipName && (
      <SailingInfoItem
        iconName={stenaSailingOnRoute}
        label={formatShipName(shipName)}
      />
    )}
    {sailingType && (
      <SailingInfoItem
        label={sailingType.label}
        iconName={stenaStatisticsBar}
      />
    )}
    {arrivalInformation && (
      <SailingInfoItem label={arrivalInformation} iconName={stenaClock} />
    )}
    {releasedAt && (
      <SailingInfoItem
        label={`Released at ${formatDateTime(parseISO(releasedAt), dateFormat)}`}
        iconName={stenaCheckCircle}
        iconColor={cssColor("--lhds-color-green-500")}
      />
    )}
  </>
);
